import "@plaudit/query-loop.api";

export class SearchIntegration {
	private searchLocationPosition: google.maps.LatLngLiteral|null|undefined = undefined;

	public constructor(private readonly queryLoopForm: HTMLFormElement) {}

	public getSearchedLocationPosition(update = false): google.maps.LatLngLiteral | null {
		if (!update && this.searchLocationPosition !== undefined) {
			return this.searchLocationPosition;
		}

		let latLng: string[];
		const location = plaudit.queryLoop.forms.get(this.queryLoopForm).getField({type: 'location'})?.getValue().toString();
		if (location && (latLng = location.substring(location.lastIndexOf(':') + 1)?.split(',')).length === 2) {
			this.searchLocationPosition = {lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1])};
		} else {
			this.searchLocationPosition = null;
		}
		return this.searchLocationPosition;
	}
}
